/* unplugin-vue-components disabled */import { render } from "./ColorPickerBoard.vue?vue&type=template&id=26f62e98&scoped=true&ts=true"
import script from "./ColorPickerBoard.vue?vue&type=script&lang=ts"
export * from "./ColorPickerBoard.vue?vue&type=script&lang=ts"

import "./ColorPickerBoard.vue?vue&type=style&index=0&id=26f62e98&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26f62e98"]])

export default __exports__